import React from 'react';

export interface ConditionalWrapProps {
  condition: boolean;
  wrap: (children: JSX.Element) => JSX.Element;
  children: any;
}

const ConditionalWrap = ({ condition, children, wrap }: ConditionalWrapProps) =>
  condition ? React.cloneElement(wrap(children)) : children;

export default ConditionalWrap;
